module.exports = __webpack_public_path__ + "img/BTC.997bb5db.svg";